<modal
  [id]="id()"
  [header]="header()"
  [closeButtonEnabled]="true"
  [showHeaderDivider]="true"
  [showFooterDivider]="false"
  [widthClass]="'tw-w-[343px] lg:tw-w-[600px]'"
  [heightClass]="'tw-h-auto'"
  [enableBackdropClose]="!isSending()"
  [escapeToClose]="!isSending()"
  (onCloseModal)="onModalClose()"
>
  <div slot="body" class="tw-flex tw-flex-col tw-gap-8">
    <div class="tw-flex tw-flex-col tw-gap-4 tw-w-full">
      <div class="tw-flex tw-flex-col tw-gap-3 tw-w-full tw-text-sm lg:tw-text-base tw-leading-normal">
        <p class="tw-m-0 tw-font-normal tw-text-gray-700">You are about to send invitation {{ unitNoun().plural }} to {{ recipientLabel() }}.</p>
        <ul class="tw-m-0 tw-flex tw-flex-col tw-gap-3 tw-list-disc tw-ps-[21px] lg:tw-ps-6 tw-font-medium tw-text-gray-900">
          <li>Cost per {{ unitNoun().singular }}: {{ unitPriceLabel() }}</li>
          <li>Estimated cost: up to {{ totalCostLabel() }} ({{ recipientCountLabel() }} × {{ unitPriceLabel() }})</li>
        </ul>
      </div>

      <div class="tw-flex tw-items-start lg:tw-items-center tw-gap-2 tw-w-full tw-p-3 tw-rounded-lg tw-border tw-border-[#A4CAFE] tw-bg-[#EBF5FF]">
        <span class="tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-w-5 tw-h-5">
          <img [src]="infoIconSrc" width="18" height="18" alt="" />
        </span>
        <p class="tw-m-0 tw-flex-1 tw-min-w-0 tw-text-xs lg:tw-text-sm tw-font-normal tw-leading-normal tw-text-gray-700">
          You’ll only be charged for successfully delivered invitations.
        </p>
      </div>

      <p class="tw-m-0 tw-text-sm lg:tw-text-base tw-font-normal tw-leading-normal tw-text-gray-700">Do you want to proceed?</p>
    </div>

    <div class="tw-flex tw-w-full tw-flex-col-reverse tw-gap-3 lg:tw-flex-row lg:tw-items-start lg:tw-justify-between">
      <button
        type="button"
        class="tw-flex tw-w-full lg:tw-w-auto tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-px-5 tw-py-2.5 tw-text-sm tw-font-medium tw-leading-normal tw-text-gray-800 tw-cursor-pointer"
        [disabled]="isSending()"
        (click)="onBack()"
      >
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_590_1114)">
        <path d="M9.71558 0.5C9.82748 0.498999 9.9393 0.520486 10.0437 0.564453C10.1481 0.608422 10.2437 0.674198 10.325 0.757812C10.4063 0.841521 10.4711 0.942228 10.5154 1.05371C10.5597 1.16519 10.5828 1.28502 10.5818 1.40625C10.5808 1.52751 10.5557 1.64719 10.5095 1.75781C10.4749 1.84065 10.4285 1.91674 10.3728 1.98438L10.3142 2.0498L10.3083 2.05566L5.83472 6.66016L5.49683 7.00879L5.83472 7.35742L10.3083 11.9619C10.4293 12.0866 10.5135 12.247 10.5476 12.4238C10.5818 12.6009 10.5636 12.7843 10.4968 12.9502C10.4301 13.1159 10.3184 13.2556 10.1775 13.3525C10.0367 13.4494 9.87223 13.499 9.70581 13.499C9.48316 13.4988 9.26621 13.409 9.10425 13.2422L3.67163 7.64844C3.50909 7.48107 3.41485 7.2515 3.41479 7.00879C3.41479 6.766 3.50904 6.53558 3.67163 6.36816L9.10425 0.775391L9.11108 0.768555C9.19093 0.683576 9.28584 0.617083 9.3894 0.571289C9.49305 0.525464 9.60374 0.501025 9.71558 0.5Z" fill="#1F2A37" stroke="#1F2A37"/>
        </g>
        <defs>
        <clipPath id="clip0_590_1114">
        <rect width="14" height="14" fill="white"/>
        </clipPath>
        </defs>
      </svg>        
        Back
      </button>
      <button
        type="button"
        class="tw-flex tw-w-full lg:tw-w-auto tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-border-0 tw-bg-blue-600 tw-px-5 tw-py-2.5 tw-text-sm tw-font-medium tw-leading-normal tw-text-white tw-cursor-pointer"
        [disabled]="isSending()"
        [attr.aria-busy]="isSending()"
        (click)="onConfirm()"
      >
        {{ confirmLabel() }}
      </button>
    </div>
  </div>
</modal>
